<template>
  <div>
    <medical-view :claim="claimSelected" :modal="modalMedicalView" @closeModal="modalMedicalView = false" @refreshData="refreshData"></medical-view>
    <traces :claim="claimSelected" :modal="modalTrace" @closeModal="modalTrace = false"></traces>
    <table-search @data-filter="filterClaims($event)"></table-search>
    <agreed-amount :claim="claimSelected" :modal="modalAgreedAmount" @closeModal="modalAgreedAmount = false" @refreshData="refreshData"></agreed-amount>
    <sign-attachments :claim="claimSelected" :modal="modalSignAttachments" @closeModal="modalSignAttachments = false"></sign-attachments>
    <column-search 
      :label="columnSelected" 
      :type="columnTypeSelected" 
      :url="columnUrlSelected" 
      :modal="modalColumn"
      :other="columnOther"
      @column-filter="filterColumn($event)">
    </column-search>

    <div class="flex justify-center items-center">
      <router-link 
        :to="{ name: 'ClaimNew' }"
        class="inline-flex rounded-md border border-blue-300 px-4 py-2 bg-white text-sm leading-6 font-medium text-blue-700 shadow-sm hover:text-blue-300 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
        <svg class="w-5 h-5 mr-2 -ml-1 text-white-400" fill="currentColor" viewBox="0 0 20 20">
          <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03"></path>
        </svg>
        Nuevo Reclamo
      </router-link>
    </div>
    
    <div class="sm:px-6 lg:px-8 pt-1">
      <div class="h-full bg-white shadow-2xl">
        <div>
          <div class="sm:hidden">
            <select aria-label="Selected tab" v-model="stateSelectSelected" class="form-select block w-full">
              <option v-for="state in states" :key="state.id" :value="state.id">{{ state.name }}</option>
              <option value="0">Todos</option>
            </select>
          </div>
          <div class="hidden sm:block">
            <div class="border-b border-gray-200">
              <nav class="-mb-px flex">
                <button v-for="state in states" :key="state.id" @click="getClaims(state.id)" :class="state.id == stateSelected ? 'border-green-300' : ''" class="w-1/4 py-4 px-1 text-center border-b-2 border-transparent font-medium text-sm leading-5 text-black-500 hover:text-blue-700 hover:border-blue-300 focus:outline-none focus:text-blue-700">
                  {{ state.name }}
                </button>
                <button @click="getClaims(0)" class="w-1/4 py-4 px-1 text-center border-transparent font-medium text-sm leading-5 text-black-500 hover:text-blue-700 hover:border-blue-300 focus:outline-none focus:text-blue-700">
                  <svg
                    class="w-5 h-5"
                    :class="stateSelected == 0 ? 'text-green-400' : 'text-red-400'"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                      >
                    <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                    </path>
                  </svg>
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
      
    <div class="flex flex-col">
      <div
        class="py-12 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
      >
        <div
          class="inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow sm:rounded-lg"
        >
          <table class="min-w-full">
            <thead>
              <tr>
               <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-center text-blue-500 uppercase border-b border-blue-200 bg-blue-50"
                >
                  <center>
                    <svg
                        v-if="claims && claims.length > 0"
                        @click="toCsv"
                        class="w-7 h-7 text-green-600 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M17.453,12.691V7.723 M17.453,12.691V7.723 M1.719,12.691V7.723 M18.281,12.691V7.723 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484 M7.309,13.312h5.383c0.229,0,0.414-0.187,0.414-0.414s-0.186-0.414-0.414-0.414H7.309c-0.228,0-0.414,0.187-0.414,0.414S7.081,13.312,7.309,13.312 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M16.625,6.066h-1.449V3.168c0-0.228-0.186-0.414-0.414-0.414H5.238c-0.228,0-0.414,0.187-0.414,0.414v2.898H3.375c-0.913,0-1.656,0.743-1.656,1.656v4.969c0,0.913,0.743,1.656,1.656,1.656h1.449v2.484c0,0.228,0.187,0.414,0.414,0.414h9.523c0.229,0,0.414-0.187,0.414-0.414v-2.484h1.449c0.912,0,1.656-0.743,1.656-1.656V7.723C18.281,6.81,17.537,6.066,16.625,6.066 M5.652,3.582h8.695v2.484H5.652V3.582zM14.348,16.418H5.652v-4.969h8.695V16.418z M17.453,12.691c0,0.458-0.371,0.828-0.828,0.828h-1.449v-2.484c0-0.228-0.186-0.414-0.414-0.414H5.238c-0.228,0-0.414,0.186-0.414,0.414v2.484H3.375c-0.458,0-0.828-0.37-0.828-0.828V7.723c0-0.458,0.371-0.828,0.828-0.828h13.25c0.457,0,0.828,0.371,0.828,0.828V12.691z M7.309,13.312h5.383c0.229,0,0.414-0.187,0.414-0.414s-0.186-0.414-0.414-0.414H7.309c-0.228,0-0.414,0.187-0.414,0.414S7.081,13.312,7.309,13.312M7.309,15.383h5.383c0.229,0,0.414-0.187,0.414-0.414s-0.186-0.414-0.414-0.414H7.309c-0.228,0-0.414,0.187-0.414,0.414S7.081,15.383,7.309,15.383 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555"></path>
                    </svg>
                  </center>
                </th>

                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-center text-blue-500 uppercase border-b border-blue-200 bg-blue-50"
                >
                  #
                </th>

                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-center text-blue-500 uppercase border-b border-blue-200 bg-blue-50"
                >
                  Fecha
                  <svg
                    @click="showfilterColumn('Fecha', 'date', null, false)"
                    :class="filters.date != null ? 'text-green-400' : 'text-gray-400'"
                    class="w-3 h-3 float-right cursor-pointer"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </th>

                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-center text-blue-500 uppercase border-b border-blue-200 bg-blue-50"
                >
                  Cliente
                    <svg
                      @click="toggleClientFilters('medical')"
                      :class="filters.medical == true ? 'text-green-400' : 'text-red-400'"
                      class="w-5 h-5 float-right cursor-pointer"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      >
                      <path d="M17 10.27V4.99a1 1 0 0 0-2 0V15a5 5 0 0 1-10 0v-1.08A6 6 0 0 1 0 8V2C0 .9.9 0 2 0h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1H2v6a4 4 0 1 0 8 0V2H9a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v6a6 6 0 0 1-5 5.92V15a3 3 0 0 0 6 0V5a3 3 0 0 1 6 0v5.27a2 2 0 1 1-2 0z"></path>
                    </svg>
                    <svg
                        @click="toggleClientFilters('other_person')"
                        :class="filters.other_person == true ? 'text-green-400' : 'text-orange-500'"
                        class="w-5 h-5 float-right cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                      <path d="M15.573,11.624c0.568-0.478,0.947-1.219,0.947-2.019c0-1.37-1.108-2.569-2.371-2.569s-2.371,1.2-2.371,2.569c0,0.8,0.379,1.542,0.946,2.019c-0.253,0.089-0.496,0.2-0.728,0.332c-0.743-0.898-1.745-1.573-2.891-1.911c0.877-0.61,1.486-1.666,1.486-2.812c0-1.79-1.479-3.359-3.162-3.359S4.269,5.443,4.269,7.233c0,1.146,0.608,2.202,1.486,2.812c-2.454,0.725-4.252,2.998-4.252,5.685c0,0.218,0.178,0.396,0.395,0.396h16.203c0.218,0,0.396-0.178,0.396-0.396C18.497,13.831,17.273,12.216,15.573,11.624 M12.568,9.605c0-0.822,0.689-1.779,1.581-1.779s1.58,0.957,1.58,1.779s-0.688,1.779-1.58,1.779S12.568,10.427,12.568,9.605 M5.06,7.233c0-1.213,1.014-2.569,2.371-2.569c1.358,0,2.371,1.355,2.371,2.569S8.789,9.802,7.431,9.802C6.073,9.802,5.06,8.447,5.06,7.233 M2.309,15.335c0.202-2.649,2.423-4.742,5.122-4.742s4.921,2.093,5.122,4.742H2.309z M13.346,15.335c-0.067-0.997-0.382-1.928-0.882-2.732c0.502-0.271,1.075-0.429,1.686-0.429c1.828,0,3.338,1.385,3.535,3.161H13.346z"></path>
                    </svg>
                    <svg
                      @click="toggleClientFilters('mechanical')"
                      :class="filters.mechanical == true ? 'text-green-400' : 'text-gray-800'"
                      class="w-5 h-5 float-right cursor-pointer"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M4.68,13.716v-0.169H4.554C4.592,13.605,4.639,13.658,4.68,13.716z M11.931,6.465
	c-0.307-0.087-0.623,0.106-0.706,0.432l-1.389,5.484c-0.901,0.084-1.609,0.833-1.609,1.757c0,0.979,0.793,1.773,1.773,1.773
	c0.979,0,1.773-0.794,1.773-1.773c0-0.624-0.324-1.171-0.812-1.486l1.377-5.439C12.422,6.887,12.239,6.552,11.931,6.465z
	M10.591,14.729H9.408v-1.182h1.183V14.729z M15.32,13.716c0.04-0.058,0.087-0.11,0.126-0.169H15.32V13.716z M10,3.497
	c-3.592,0-6.503,2.911-6.503,6.503H4.68c0-2.938,2.382-5.32,5.32-5.32s5.32,2.382,5.32,5.32h1.182
	C16.502,6.408,13.591,3.497,10,3.497z M10,0.542c-5.224,0-9.458,4.234-9.458,9.458c0,5.224,4.234,9.458,9.458,9.458
	c5.224,0,9.458-4.234,9.458-9.458C19.458,4.776,15.224,0.542,10,0.542z M15.32,16.335v0.167h-0.212
	c-1.407,1.107-3.179,1.773-5.108,1.773c-1.93,0-3.701-0.666-5.108-1.773H4.68v-0.167C2.874,14.816,1.724,12.543,1.724,10
	c0-4.571,3.706-8.276,8.276-8.276c4.57,0,8.275,3.706,8.275,8.276C18.275,12.543,17.126,14.816,15.32,16.335z"></path>
                    </svg>
                </th>

                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-center text-blue-500 uppercase border-b border-blue-200 bg-blue-50"
                >
                  Seguro
                  <svg
                    @click="showfilterColumn('Seguro', 'select', 'insurance/all', true)"
                    :class="filters.insurance != null ? 'text-green-400' : 'text-gray-400'"
                    class="w-3 h-3 float-right cursor-pointer"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </th>

                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-center text-blue-500 uppercase border-b border-blue-200 bg-blue-50"
                >
                  Reclamar
                  <svg
                    @click="showfilterColumn('Reclamar', 'select', 'claimType/all', false)"
                    :class="filters.damage != null ? 'text-green-400' : 'text-gray-400'"
                    class="w-3 h-3 float-right cursor-pointer"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </th>

                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-center text-blue-500 uppercase border-b border-blue-200 bg-blue-50"
                ></th>
              </tr>
            </thead>

            <tbody class="bg-white">
              <tr v-for="(claim, index) in claims" :key="`${index}-${claim.id}`" 
                :class="isMedicalViewAll(claim) ? 'bg-red-100' : ''">
                <td
                class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                >
                  <center>
                    <img :src="require('../assets/displacement_type/'+claim.displacement_type.icon)" />
                  </center>
                </td>

                <td
                  class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                >
                  <div class="flex justify-center items-center m-1 font-medium py-1 px-2 rounded-full text-green-700 bg-green-100 border border-green-300 ">
                      <div class="text-xs font-normal leading-none max-w-full flex-initial">{{ claim.code }}</div>
                  </div>
                </td>

                <td
                  class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                >
                  <div class="text-sm text-center leading-5 text-gray-500">
                    {{ claim.created_at | fechaHora }}
                  </div>
                </td>

                <td
                  class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                >
                  <div class="text-sm text-center leading-5 text-gray-500">
                    {{ claim.person.name }}
                    <svg
                      v-if="claim.insured"
                      class="w-5 h-5 text-blue-600 float-right"
                      fill="currentColor"
                      viewBox="0 0 20 20">
							        <path d="M14.781,14.347h1.738c0.24,0,0.436-0.194,0.436-0.435v-1.739c0-0.239-0.195-0.435-0.436-0.435h-1.738c-0.239,0-0.435,0.195-0.435,0.435v1.739C14.347,14.152,14.542,14.347,14.781,14.347 M18.693,3.045H1.307c-0.48,0-0.869,0.39-0.869,0.869v12.17c0,0.479,0.389,0.869,0.869,0.869h17.387c0.479,0,0.869-0.39,0.869-0.869V3.915C19.562,3.435,19.173,3.045,18.693,3.045 M18.693,16.085H1.307V9.13h17.387V16.085z M18.693,5.653H1.307V3.915h17.387V5.653zM3.48,12.608h7.824c0.24,0,0.435-0.195,0.435-0.436c0-0.239-0.194-0.435-0.435-0.435H3.48c-0.24,0-0.435,0.195-0.435,0.435C3.045,12.413,3.24,12.608,3.48,12.608 M3.48,14.347h6.085c0.24,0,0.435-0.194,0.435-0.435s-0.195-0.435-0.435-0.435H3.48c-0.24,0-0.435,0.194-0.435,0.435S3.24,14.347,3.48,14.347"></path>
						        </svg>
                    <svg
                        v-if="claim.medical"
                        class="w-5 h-5 text-red-400 float-right"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                      <path d="M17 10.27V4.99a1 1 0 0 0-2 0V15a5 5 0 0 1-10 0v-1.08A6 6 0 0 1 0 8V2C0 .9.9 0 2 0h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1H2v6a4 4 0 1 0 8 0V2H9a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v6a6 6 0 0 1-5 5.92V15a3 3 0 0 0 6 0V5a3 3 0 0 1 6 0v5.27a2 2 0 1 1-2 0z"></path>
                    </svg>
                    <svg
                        v-if="claim.other_person"
                        class="w-5 h-5 text-orange-500 float-right"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                      <path d="M15.573,11.624c0.568-0.478,0.947-1.219,0.947-2.019c0-1.37-1.108-2.569-2.371-2.569s-2.371,1.2-2.371,2.569c0,0.8,0.379,1.542,0.946,2.019c-0.253,0.089-0.496,0.2-0.728,0.332c-0.743-0.898-1.745-1.573-2.891-1.911c0.877-0.61,1.486-1.666,1.486-2.812c0-1.79-1.479-3.359-3.162-3.359S4.269,5.443,4.269,7.233c0,1.146,0.608,2.202,1.486,2.812c-2.454,0.725-4.252,2.998-4.252,5.685c0,0.218,0.178,0.396,0.395,0.396h16.203c0.218,0,0.396-0.178,0.396-0.396C18.497,13.831,17.273,12.216,15.573,11.624 M12.568,9.605c0-0.822,0.689-1.779,1.581-1.779s1.58,0.957,1.58,1.779s-0.688,1.779-1.58,1.779S12.568,10.427,12.568,9.605 M5.06,7.233c0-1.213,1.014-2.569,2.371-2.569c1.358,0,2.371,1.355,2.371,2.569S8.789,9.802,7.431,9.802C6.073,9.802,5.06,8.447,5.06,7.233 M2.309,15.335c0.202-2.649,2.423-4.742,5.122-4.742s4.921,2.093,5.122,4.742H2.309z M13.346,15.335c-0.067-0.997-0.382-1.928-0.882-2.732c0.502-0.271,1.075-0.429,1.686-0.429c1.828,0,3.338,1.385,3.535,3.161H13.346z"></path>
                    </svg>
                    <svg
                      v-if="claim.mechanical"
                      class="w-5 h-5 text-gray-800 float-right"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M4.68,13.716v-0.169H4.554C4.592,13.605,4.639,13.658,4.68,13.716z M11.931,6.465
	c-0.307-0.087-0.623,0.106-0.706,0.432l-1.389,5.484c-0.901,0.084-1.609,0.833-1.609,1.757c0,0.979,0.793,1.773,1.773,1.773
	c0.979,0,1.773-0.794,1.773-1.773c0-0.624-0.324-1.171-0.812-1.486l1.377-5.439C12.422,6.887,12.239,6.552,11.931,6.465z
	M10.591,14.729H9.408v-1.182h1.183V14.729z M15.32,13.716c0.04-0.058,0.087-0.11,0.126-0.169H15.32V13.716z M10,3.497
	c-3.592,0-6.503,2.911-6.503,6.503H4.68c0-2.938,2.382-5.32,5.32-5.32s5.32,2.382,5.32,5.32h1.182
	C16.502,6.408,13.591,3.497,10,3.497z M10,0.542c-5.224,0-9.458,4.234-9.458,9.458c0,5.224,4.234,9.458,9.458,9.458
	c5.224,0,9.458-4.234,9.458-9.458C19.458,4.776,15.224,0.542,10,0.542z M15.32,16.335v0.167h-0.212
	c-1.407,1.107-3.179,1.773-5.108,1.773c-1.93,0-3.701-0.666-5.108-1.773H4.68v-0.167C2.874,14.816,1.724,12.543,1.724,10
	c0-4.571,3.706-8.276,8.276-8.276c4.57,0,8.275,3.706,8.275,8.276C18.275,12.543,17.126,14.816,15.32,16.335z"></path>
                    </svg>
                  </div>
                </td>

                <td
                  class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                >
                  <div v-if="claim.insurance" class="text-sm text-center leading-5 text-gray-500">
                    {{ claim.insurance.name }}
                    <svg
                      v-if="claim"
                      @click="modalTrace = true; claimSelected = claim"
                      class="w-5 h-5 text-gray-400 float-right cursor-pointer"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10,1.445c-4.726,0-8.555,3.829-8.555,8.555c0,4.725,3.829,8.555,8.555,8.555c4.725,0,8.555-3.83,8.555-8.555C18.555,5.274,14.725,1.445,10,1.445 M10,17.654c-4.221,0-7.654-3.434-7.654-7.654c0-4.221,3.433-7.654,7.654-7.654c4.222,0,7.654,3.433,7.654,7.654C17.654,14.221,14.222,17.654,10,17.654 M14.39,10c0,0.248-0.203,0.45-0.45,0.45H6.06c-0.248,0-0.45-0.203-0.45-0.45s0.203-0.45,0.45-0.45h7.879C14.187,9.55,14.39,9.752,14.39,10 M14.39,12.702c0,0.247-0.203,0.449-0.45,0.449H6.06c-0.248,0-0.45-0.202-0.45-0.449c0-0.248,0.203-0.451,0.45-0.451h7.879C14.187,12.251,14.39,12.454,14.39,12.702 M14.39,7.298c0,0.248-0.203,0.45-0.45,0.45H6.06c-0.248,0-0.45-0.203-0.45-0.45s0.203-0.45,0.45-0.45h7.879C14.187,6.848,14.39,7.051,14.39,7.298">
                      </path>
                    </svg>
                  </div>
                </td>

                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200"
                >

                  <div v-for="t in claim.types" :key="t.id" class="flex justify-center items-center m-1 font-medium py-1 px-2 bg-white rounded-full text-gray-700 bg-gray-100 border border-gray-300 ">
                    <div class="text-xs font-normal leading-none max-w-full flex-initial">{{ t.name }}</div>
                  </div>
                  <span v-html="extraTypes(claim)"></span>
                  
                </td>

                <td class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200">
                  <div class="flex flex-row-reverse">
                      <svg
                        v-if="isSysa"
                        @click="remove(claim)"
                        class="w-5 h-5 mr-2 -ml-1 text-red-600 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M17.114,3.923h-4.589V2.427c0-0.252-0.207-0.459-0.46-0.459H7.935c-0.252,0-0.459,0.207-0.459,0.459v1.496h-4.59c-0.252,0-0.459,0.205-0.459,0.459c0,0.252,0.207,0.459,0.459,0.459h1.51v12.732c0,0.252,0.207,0.459,0.459,0.459h10.29c0.254,0,0.459-0.207,0.459-0.459V4.841h1.511c0.252,0,0.459-0.207,0.459-0.459C17.573,4.127,17.366,3.923,17.114,3.923M8.394,2.886h3.214v0.918H8.394V2.886z M14.686,17.114H5.314V4.841h9.372V17.114z M12.525,7.306v7.344c0,0.252-0.207,0.459-0.46,0.459s-0.458-0.207-0.458-0.459V7.306c0-0.254,0.205-0.459,0.458-0.459S12.525,7.051,12.525,7.306M8.394,7.306v7.344c0,0.252-0.207,0.459-0.459,0.459s-0.459-0.207-0.459-0.459V7.306c0-0.254,0.207-0.459,0.459-0.459S8.394,7.051,8.394,7.306">
                        </path>
                      </svg>

                      <svg
                        v-if="stateSelected == stateMedicalView || ((stateSelected == stateInicial || stateSelected == stateComplete) && claim.medical)"
                        @click="modalMedicalView = true; claimSelected = claim"
                        class="w-4 h-4 mr-2 -ml-1 text-red-600 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M17 10.27V4.99a1 1 0 0 0-2 0V15a5 5 0 0 1-10 0v-1.08A6 6 0 0 1 0 8V2C0 .9.9 0 2 0h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1H2v6a4 4 0 1 0 8 0V2H9a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v6a6 6 0 0 1-5 5.92V15a3 3 0 0 0 6 0V5a3 3 0 0 1 6 0v5.27a2 2 0 1 1-2 0z">
                        </path>
                      </svg>

                      <svg
                        v-if="stateSelected == stateInNegotiation"
                        @click="modalAgreedAmount = true; claimSelected = claim"
                        class="w-5 h-5 mr-2 -ml-1 text-blue-600 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M5.229,6.531H4.362c-0.239,0-0.434,0.193-0.434,0.434c0,0.239,0.194,0.434,0.434,0.434h0.868c0.24,0,0.434-0.194,0.434-0.434C5.663,6.724,5.469,6.531,5.229,6.531 M10,6.531c-1.916,0-3.47,1.554-3.47,3.47c0,1.916,1.554,3.47,3.47,3.47c1.916,0,3.47-1.555,3.47-3.47C13.47,8.084,11.916,6.531,10,6.531 M11.4,11.447c-0.071,0.164-0.169,0.299-0.294,0.406c-0.124,0.109-0.27,0.191-0.437,0.248c-0.167,0.057-0.298,0.09-0.492,0.098v0.402h-0.35v-0.402c-0.21-0.004-0.352-0.039-0.527-0.1c-0.175-0.064-0.324-0.154-0.449-0.27c-0.124-0.115-0.221-0.258-0.288-0.428c-0.068-0.17-0.1-0.363-0.096-0.583h0.664c-0.004,0.259,0.052,0.464,0.169,0.613c0.116,0.15,0.259,0.229,0.527,0.236v-1.427c-0.159-0.043-0.268-0.095-0.425-0.156c-0.157-0.061-0.299-0.139-0.425-0.235C8.852,9.752,8.75,9.631,8.672,9.486C8.594,9.34,8.556,9.16,8.556,8.944c0-0.189,0.036-0.355,0.108-0.498c0.072-0.144,0.169-0.264,0.292-0.36c0.122-0.097,0.263-0.17,0.422-0.221c0.159-0.052,0.277-0.077,0.451-0.077V7.401h0.35v0.387c0.174,0,0.29,0.023,0.445,0.071c0.155,0.047,0.29,0.118,0.404,0.212c0.115,0.095,0.206,0.215,0.274,0.359c0.067,0.146,0.103,0.315,0.103,0.508H10.74c-0.007-0.201-0.06-0.354-0.154-0.46c-0.096-0.106-0.199-0.159-0.408-0.159v1.244c0.174,0.047,0.296,0.102,0.462,0.165c0.167,0.063,0.314,0.144,0.443,0.241c0.128,0.099,0.23,0.221,0.309,0.366c0.077,0.146,0.116,0.324,0.116,0.536C11.509,11.092,11.473,11.283,11.4,11.447 M18.675,4.795H1.326c-0.479,0-0.868,0.389-0.868,0.868v8.674c0,0.479,0.389,0.867,0.868,0.867h17.349c0.479,0,0.867-0.389,0.867-0.867V5.664C19.542,5.184,19.153,4.795,18.675,4.795M1.76,5.664c0.24,0,0.434,0.193,0.434,0.434C2.193,6.336,2,6.531,1.76,6.531S1.326,6.336,1.326,6.097C1.326,5.857,1.52,5.664,1.76,5.664 M1.76,14.338c-0.24,0-0.434-0.195-0.434-0.434c0-0.24,0.194-0.434,0.434-0.434s0.434,0.193,0.434,0.434C2.193,14.143,2,14.338,1.76,14.338 M18.241,14.338c-0.24,0-0.435-0.195-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,14.143,18.48,14.338,18.241,14.338 M18.675,12.682c-0.137-0.049-0.281-0.08-0.434-0.08c-0.719,0-1.302,0.584-1.302,1.303c0,0.152,0.031,0.297,0.08,0.434H2.981c0.048-0.137,0.08-0.281,0.08-0.434c0-0.719-0.583-1.303-1.301-1.303c-0.153,0-0.297,0.031-0.434,0.08V7.318c0.136,0.049,0.28,0.08,0.434,0.08c0.718,0,1.301-0.583,1.301-1.301c0-0.153-0.032-0.298-0.08-0.434H17.02c-0.049,0.136-0.08,0.28-0.08,0.434c0,0.718,0.583,1.301,1.302,1.301c0.152,0,0.297-0.031,0.434-0.08V12.682z M18.241,6.531c-0.24,0-0.435-0.194-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,6.336,18.48,6.531,18.241,6.531 M9.22,8.896c0,0.095,0.019,0.175,0.058,0.242c0.039,0.066,0.088,0.124,0.148,0.171c0.061,0.047,0.13,0.086,0.21,0.115c0.079,0.028,0.11,0.055,0.192,0.073V8.319c-0.21,0-0.322,0.044-0.437,0.132C9.277,8.54,9.22,8.688,9.22,8.896 M15.639,12.602h-0.868c-0.239,0-0.434,0.195-0.434,0.434c0,0.24,0.194,0.436,0.434,0.436h0.868c0.24,0,0.434-0.195,0.434-0.436C16.072,12.797,15.879,12.602,15.639,12.602 M10.621,10.5c-0.068-0.052-0.145-0.093-0.23-0.124c-0.086-0.031-0.123-0.06-0.212-0.082v1.374c0.209-0.016,0.332-0.076,0.465-0.186c0.134-0.107,0.201-0.281,0.201-0.516c0-0.11-0.02-0.202-0.062-0.277C10.743,10.615,10.688,10.551,10.621,10.5"></path>
                      </svg>

                      <svg
                        v-if="stateSelected == statePendingPayment"
                        @click="modalSignAttachments = true; claimSelected = claim"
                        class="w-5 h-5 mr-2 -ml-1 text-black cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M4.317,16.411c-1.423-1.423-1.423-3.737,0-5.16l8.075-7.984c0.994-0.996,2.613-0.996,3.611,0.001C17,4.264,17,5.884,16.004,6.88l-8.075,7.984c-0.568,0.568-1.493,0.569-2.063-0.001c-0.569-0.569-0.569-1.495,0-2.064L9.93,8.828c0.145-0.141,0.376-0.139,0.517,0.005c0.141,0.144,0.139,0.375-0.006,0.516l-4.062,3.968c-0.282,0.282-0.282,0.745,0.003,1.03c0.285,0.284,0.747,0.284,1.032,0l8.074-7.985c0.711-0.71,0.711-1.868-0.002-2.579c-0.711-0.712-1.867-0.712-2.58,0l-8.074,7.984c-1.137,1.137-1.137,2.988,0.001,4.127c1.14,1.14,2.989,1.14,4.129,0l6.989-6.896c0.143-0.142,0.375-0.14,0.516,0.003c0.143,0.143,0.141,0.374-0.002,0.516l-6.988,6.895C8.054,17.836,5.743,17.836,4.317,16.411"></path>
                      </svg>

                      <svg
                        v-if="stateSelected == statePendingPayment || stateSelected == statePendingCommission || stateSelected == stateClosed"
                        @click="viewInfoPayment(claim)"
                        class="w-5 h-5 mr-2 -ml-1 text-green-600 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M5.229,6.531H4.362c-0.239,0-0.434,0.193-0.434,0.434c0,0.239,0.194,0.434,0.434,0.434h0.868c0.24,0,0.434-0.194,0.434-0.434C5.663,6.724,5.469,6.531,5.229,6.531 M10,6.531c-1.916,0-3.47,1.554-3.47,3.47c0,1.916,1.554,3.47,3.47,3.47c1.916,0,3.47-1.555,3.47-3.47C13.47,8.084,11.916,6.531,10,6.531 M11.4,11.447c-0.071,0.164-0.169,0.299-0.294,0.406c-0.124,0.109-0.27,0.191-0.437,0.248c-0.167,0.057-0.298,0.09-0.492,0.098v0.402h-0.35v-0.402c-0.21-0.004-0.352-0.039-0.527-0.1c-0.175-0.064-0.324-0.154-0.449-0.27c-0.124-0.115-0.221-0.258-0.288-0.428c-0.068-0.17-0.1-0.363-0.096-0.583h0.664c-0.004,0.259,0.052,0.464,0.169,0.613c0.116,0.15,0.259,0.229,0.527,0.236v-1.427c-0.159-0.043-0.268-0.095-0.425-0.156c-0.157-0.061-0.299-0.139-0.425-0.235C8.852,9.752,8.75,9.631,8.672,9.486C8.594,9.34,8.556,9.16,8.556,8.944c0-0.189,0.036-0.355,0.108-0.498c0.072-0.144,0.169-0.264,0.292-0.36c0.122-0.097,0.263-0.17,0.422-0.221c0.159-0.052,0.277-0.077,0.451-0.077V7.401h0.35v0.387c0.174,0,0.29,0.023,0.445,0.071c0.155,0.047,0.29,0.118,0.404,0.212c0.115,0.095,0.206,0.215,0.274,0.359c0.067,0.146,0.103,0.315,0.103,0.508H10.74c-0.007-0.201-0.06-0.354-0.154-0.46c-0.096-0.106-0.199-0.159-0.408-0.159v1.244c0.174,0.047,0.296,0.102,0.462,0.165c0.167,0.063,0.314,0.144,0.443,0.241c0.128,0.099,0.23,0.221,0.309,0.366c0.077,0.146,0.116,0.324,0.116,0.536C11.509,11.092,11.473,11.283,11.4,11.447 M18.675,4.795H1.326c-0.479,0-0.868,0.389-0.868,0.868v8.674c0,0.479,0.389,0.867,0.868,0.867h17.349c0.479,0,0.867-0.389,0.867-0.867V5.664C19.542,5.184,19.153,4.795,18.675,4.795M1.76,5.664c0.24,0,0.434,0.193,0.434,0.434C2.193,6.336,2,6.531,1.76,6.531S1.326,6.336,1.326,6.097C1.326,5.857,1.52,5.664,1.76,5.664 M1.76,14.338c-0.24,0-0.434-0.195-0.434-0.434c0-0.24,0.194-0.434,0.434-0.434s0.434,0.193,0.434,0.434C2.193,14.143,2,14.338,1.76,14.338 M18.241,14.338c-0.24,0-0.435-0.195-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,14.143,18.48,14.338,18.241,14.338 M18.675,12.682c-0.137-0.049-0.281-0.08-0.434-0.08c-0.719,0-1.302,0.584-1.302,1.303c0,0.152,0.031,0.297,0.08,0.434H2.981c0.048-0.137,0.08-0.281,0.08-0.434c0-0.719-0.583-1.303-1.301-1.303c-0.153,0-0.297,0.031-0.434,0.08V7.318c0.136,0.049,0.28,0.08,0.434,0.08c0.718,0,1.301-0.583,1.301-1.301c0-0.153-0.032-0.298-0.08-0.434H17.02c-0.049,0.136-0.08,0.28-0.08,0.434c0,0.718,0.583,1.301,1.302,1.301c0.152,0,0.297-0.031,0.434-0.08V12.682z M18.241,6.531c-0.24,0-0.435-0.194-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,6.336,18.48,6.531,18.241,6.531 M9.22,8.896c0,0.095,0.019,0.175,0.058,0.242c0.039,0.066,0.088,0.124,0.148,0.171c0.061,0.047,0.13,0.086,0.21,0.115c0.079,0.028,0.11,0.055,0.192,0.073V8.319c-0.21,0-0.322,0.044-0.437,0.132C9.277,8.54,9.22,8.688,9.22,8.896 M15.639,12.602h-0.868c-0.239,0-0.434,0.195-0.434,0.434c0,0.24,0.194,0.436,0.434,0.436h0.868c0.24,0,0.434-0.195,0.434-0.436C16.072,12.797,15.879,12.602,15.639,12.602 M10.621,10.5c-0.068-0.052-0.145-0.093-0.23-0.124c-0.086-0.031-0.123-0.06-0.212-0.082v1.374c0.209-0.016,0.332-0.076,0.465-0.186c0.134-0.107,0.201-0.281,0.201-0.516c0-0.11-0.02-0.202-0.062-0.277C10.743,10.615,10.688,10.551,10.621,10.5"></path>
                      </svg>

                      <svg
                        @click="edit(claim)"
                        class="w-5 h-5 mr-2 -ml-1 text-green-600 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M18.303,4.742l-1.454-1.455c-0.171-0.171-0.475-0.171-0.646,0l-3.061,3.064H2.019c-0.251,0-0.457,0.205-0.457,0.456v9.578c0,0.251,0.206,0.456,0.457,0.456h13.683c0.252,0,0.457-0.205,0.457-0.456V7.533l2.144-2.146C18.481,5.208,18.483,4.917,18.303,4.742 M15.258,15.929H2.476V7.263h9.754L9.695,9.792c-0.057,0.057-0.101,0.13-0.119,0.212L9.18,11.36h-3.98c-0.251,0-0.457,0.205-0.457,0.456c0,0.253,0.205,0.456,0.457,0.456h4.336c0.023,0,0.899,0.02,1.498-0.127c0.312-0.077,0.55-0.137,0.55-0.137c0.08-0.018,0.155-0.059,0.212-0.118l3.463-3.443V15.929z M11.241,11.156l-1.078,0.267l0.267-1.076l6.097-6.091l0.808,0.808L11.241,11.156z">
                        </path>
                      </svg>

                      <svg
                        @click="show(claim)"
                        class="w-5 h-5 mr-2 -ml-1 text-blue-600 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M10,6.978c-1.666,0-3.022,1.356-3.022,3.022S8.334,13.022,10,13.022s3.022-1.356,3.022-3.022S11.666,6.978,10,6.978M10,12.267c-1.25,0-2.267-1.017-2.267-2.267c0-1.25,1.016-2.267,2.267-2.267c1.251,0,2.267,1.016,2.267,2.267C12.267,11.25,11.251,12.267,10,12.267 M18.391,9.733l-1.624-1.639C14.966,6.279,12.563,5.278,10,5.278S5.034,6.279,3.234,8.094L1.609,9.733c-0.146,0.147-0.146,0.386,0,0.533l1.625,1.639c1.8,1.815,4.203,2.816,6.766,2.816s4.966-1.001,6.767-2.816l1.624-1.639C18.536,10.119,18.536,9.881,18.391,9.733 M16.229,11.373c-1.656,1.672-3.868,2.594-6.229,2.594s-4.573-0.922-6.23-2.594L2.41,10l1.36-1.374C5.427,6.955,7.639,6.033,10,6.033s4.573,0.922,6.229,2.593L17.59,10L16.229,11.373z">
                        </path>
                      </svg>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <table-pagination :meta="meta" :links="links" @data-paginate="getClaimsPaginate($event)"></table-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import TableSearch from '@/components/TableSearch'
import TablePagination from '@/components/TablePagination'
import Traces from '@/components/Traces'
import ColumnSearch from '@/components/ColumnSearch'
import MedicalView from '@/components/MedicalView'
import AgreedAmount from '@/components/AgreedAmount'
import SignAttachments from '@/components/SignAttachments'
import { ConstantMap } from '@/constant.js'
import '@/filter.js'

export default {
  components: { TableSearch, TablePagination, Traces, ColumnSearch, MedicalView, AgreedAmount, SignAttachments },

  data() {
    return {
      states: null,
      claims: null,
      links: null,
      meta: null,
      stateSelected: null,
      stateSelectSelected: ConstantMap.STATE_INICIAL,
      stateMedicalView: ConstantMap.STATE_MEDICAL_VIEW,
      stateInicial: ConstantMap.STATE_INICIAL,
      stateComplete: ConstantMap.STATE_COMPLETE,
      stateInNegotiation: ConstantMap.STATE_IN_NEGOTIATION,
      statePendingPayment: ConstantMap.STATE_PENDING_PAYMENT,
      statePendingCommission: ConstantMap.STATE_PENDING_COMMISSION,
      stateClosed: ConstantMap.STATE_CLOSED,
      claimSelected: null,
      modalTrace: false,
      isSysa: false,
      query: '',
      columnSelected: null,
      columnTypeSelected: null,
      columnUrlSelected: null,
      columnOther: null,
      filters: {
        date: null,
        insurance: null,
        damage: null,
        medical: false,
        other_person: false,
        mechanical: false
      },
      modalColumn: false,
      modalMedicalView: false,
      modalAgreedAmount: false,
      modalSignAttachments: false
    }
  },

  mounted() {
    this.getStates()
    if (localStorage.stateSelected) {
      this.stateSelectSelected = localStorage.stateSelected
    }
    this.getClaims(this.stateSelectSelected)
    const user = JSON.parse(localStorage.getItem('user'))
    this.isSysa = (user.user.roles.indexOf("SYSA") !== -1)
  },

  computed: {
    perPage() {
      return (this.meta && this.meta.per_page) || 10
    },
  },

  watch: {
    stateSelectSelected (value) {
      this.getClaims(value)
    }
  },

  methods: {
    async getClaimsPaginate(paginate) {
      const perPage = paginate.perPage
      const page = paginate.page
      const { data, links, meta } = await this.$http.get(`/claims/state/${this.stateSelected}/${perPage}?page=${page}`)

      this.claims = data
      this.links = links
      this.meta = meta
    },
    async getClaims(stateId) {
      localStorage.stateSelected = stateId
      this.stateSelected = stateId
      if (this.query == ''){
        const { data, links, meta } = await this.$http.get(`/claims/filter/null/${this.stateSelected}?perPage=${this.perPage}`, {params: {filters: this.filters}})

        this.claims = data
        this.links = links
        this.meta = meta

      } else {
        const { data, links, meta } = await this.$http.get(`/claims/filter/${this.query}/${this.stateSelected}?perPage=${this.perPage}`, {params: {filters: this.filters}})

        this.claims = data
        this.links = links
        this.meta = meta
      }
    },
    async getStates() {
      this.states = await this.$http.get('/claimState/all')
    },
    show(claim) {
      this.$router.push(`/claims/${claim.id}`)
    },
    edit(claim){
      this.$router.push(`/claim/${claim.id}`)
    },
    remove(claim) {
      this.$alertify.confirmWithTitle(
        'Eliminar Reclamo',
        `¿Esta seguro que desea eliminar el reclamo ${claim.code}?`,
        async () => {
          try {
            this.loading = true
            const resp = await this.$http.delete(`/claims/${claim.id}`)
            this.filterClaims('')
            this.$alertify.success('Reclamo eliminado!') 
            this.loading = false
          } catch (error) {
            this.loading = false
            this.$alertify.error('ERROR. No se ha podido eliminar el reclamo!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    async filterClaims(query) {
      this.query = query
      this.getClaims(this.stateSelected)
    },
    showfilterColumn(columnName, columnType, columnUrl, columnOther){
      this.columnSelected = columnName
      this.columnTypeSelected = columnType
      this.columnUrlSelected = columnUrl
      this.columnOther = columnOther
      this.modalColumn = true
    },
    async filterColumn(value) {
      this.columnFilter = value
      switch(this.columnSelected) {
        case 'Fecha':
          this.filters.date = value
          break;
        case 'Seguro':
          this.filters.insurance = value
          break;
        case 'Reclamar':
          this.filters.damage = value
          break;
      }
      const query = (this.query != '') ? this.query : null 
      const { data, links, meta } = await this.$http.get(`/claims/filter/${query}/${this.stateSelected}?perPage=${this.perPage}`, {params: {filters: this.filters}})

      this.claims = data
      this.links = links
      this.meta = meta
      this.modalColumn = false
    },
    async toggleClientFilters(filter) {
      switch(filter) {
        case 'medical':
          this.filters.medical = !this.filters.medical
          break;
        case 'other_person':
          this.filters.other_person = !this.filters.other_person
          break;
        case 'mechanical':
          this.filters.mechanical = !this.filters.mechanical
          break;
      }
      const query = (this.query != '') ? this.query : null 
      const { data, links, meta } = await this.$http.get(`/claims/filter/${query}/${this.stateSelected}?perPage=${this.perPage}`, {params: {filters: this.filters}})

      this.claims = data
      this.links = links
      this.meta = meta
    },
    async toCsv() {
      const query = (this.query != '') ? this.query : null 
      const response = await this.$http.get(`/claims/csv/${query}/${this.stateSelected}`, {params: {filters: this.filters}})
      const linkSource = response.csv
      const downloadLink = document.createElement("a")
      
      downloadLink.href = linkSource
      downloadLink.download = 'export_'+Date.now()+'.csv' 
      downloadLink.click()
    },
    isMedicalViewAll(claim){
      let isVictimAll = true
      let isMedicalDateHour = false

      if (claim.state.id == ConstantMap.STATE_MEDICAL_VIEW){
        if ((claim.types.filter(t => t.id == ConstantMap.CLAIM_TYPE_INJURIES).length > 0) 
        && (claim.medical_date_hour != null)){
          isMedicalDateHour = true
          claim.victims.forEach(victim => {
            if (victim.medical_date_hour == null){
              isVictimAll = false
            }
          })
        }
      }

      return (isVictimAll && isMedicalDateHour)
    },
    refreshData(claimId){
      this.claims = this.claims.filter(claim => claim.id != claimId)
    },
    viewInfoPayment(claim){
      this.$alertify.alert(
        `${claim.code} - ${claim.state.name}`, 
        `<b>Monto Acordado</b><br>$ ${claim.amount_agreed}<br><br><b>Comisión</b><br>$ ${claim.amount_commission}`
      )
    },
    extraTypes(claim){
      let typesClaims = []
      claim.types.forEach(type => {
        typesClaims.push(type)
      })

      let typesVictims = []
      claim.victims.forEach(victim => {
        if (victim.type != null){
           if (typesClaims.filter(t => t.id == victim.type.id).length == 0){
             if (typesVictims.filter(t => t.id == victim.type.id).length == 0){
               typesVictims.push(victim.type)
             }
           }
        }
        if (victim.type2 != null){
          if (typesClaims.filter(t => t.id == victim.type2.id).length == 0){
             if (typesVictims.filter(t => t.id == victim.type2.id).length == 0){
               typesVictims.push(victim.type2)
             }
           }
        }
      })
      
      let types = ""
      typesVictims.forEach(type => {
          types += `<div class="flex justify-center items-center m-1 font-medium py-1 px-2 bg-white rounded-full text-red-700 bg-red-100 border border-red-300"><div class="text-xs font-normal leading-none max-w-full flex-initial">${type.name}</div></div>`
      })
      
      return types
    }
  },
}
</script>

